export default "__VITE_ASSET__DVqWA9G7__"